import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { MENU_TAB_GROUPS, MenuService, MenuTabLink } from '../../../services/menu.service';
import { AllowListAuthStore } from '../../../shared/authorization/allow-list-auth.store';
import { UserService } from '../../../services/user.service';

/**
 * Wraps the pages of one MENU_TAB_GROUPS group (route data `menuTabGroup`) with a tab strip. The
 * pages keep their own routes and guards; only the tabs allowed for the current role are shown.
 */
@Component({
  selector: 'ppl-payroll-tabs-layout',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './payroll-tabs-layout.component.html',
  styleUrl: './payroll-tabs-layout.component.css'
})
export class PayrollTabsLayoutComponent implements OnInit, OnDestroy {
  groupLabel = '';
  tabs: MenuTabLink[] = [];
  private loadedSubscription?: Subscription;

  @HostBinding('class.has-tabs') get hasTabs(): boolean {
    return this.tabs.length > 0;
  }

  constructor(
    private route: ActivatedRoute,
    private menuService: MenuService,
    private allowListStore: AllowListAuthStore,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    // Re-evaluate on role switch, when the allow-list config reloads.
    this.loadedSubscription = this.allowListStore.loaded$.subscribe(() => this.loadTabs());
  }

  ngOnDestroy(): void {
    this.loadedSubscription?.unsubscribe();
  }

  onTabClick(tab: MenuTabLink): void {
    this.userService.setFirstSegment(tab.route);
  }

  private loadTabs(): void {
    const groupId: string = this.route.snapshot.data['menuTabGroup'];
    const programCode = this.userService.getSelectedProgram()?.program_code;
    this.groupLabel = MENU_TAB_GROUPS[groupId]?.label ?? '';
    this.tabs = programCode && this.allowListStore.isLoaded()
      ? this.menuService.getAllowedTabs(programCode, this.allowListStore.getAllowedMenuIds(), groupId)
      : [];
  }
}
